<div class="row">
  <div class="col-md-7">
    <div class="card makery-card {{(reservation.reservationStatus == 'SUCCEEDED')?'makery-closed-card-success':'makery-closed-card-accepted'}}">
      <div class="card-header border-bottom-0">
        <div class="row">
          <div class="col-md-7 col-sm-10">
            <p class="card-title">{{reservation.reservationTime + ' - '  + reservation.billingData.firstName+ ' - '  +reservation.billingData.lastName+ ' - '  + reservation.personCount + ' fő'}}
            <span *ngIf="reservation.survey.length">(</span>
            <span *ngFor="let survey of reservation.survey">{{survey | translate}}</span>
            <span  *ngIf="reservation.survey.length">)</span>
            </p>
          </div>
          <div class="col-md-5 col-sm-2 makery-control">
            <button class="btn btn-simple btn-tooltip btn-hide pr-0 pl-3"
                    data-animation="true"
                    data-container="body"
                    placement="bottom"
                    tooltip="{{'reservation.show' | translate}}"
                    (click)="setArchived()">
              <i class="fas fa-eye"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
